export { default as NewContactForm } from './ContactForm';
export { default as PersonalForm } from './PersonalForm';
export { default as BuildingForm } from './BuildingForm';
export { default as DirectionForm } from './AddressForm';
export { default as Pagination } from './Pagination';
export { default as BuildingsComponent } from './BuildingsComponent';
